export enum GameSessionsStoreStatus {
  Loading = 'loading',
  Updating = 'updating',
}
